import React from 'react'

import Base from '../_Base'

const Android24 = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.21719 19.7166L9.99219 10.9666L13.0839 14.05L2.65052 19.8333C2.25052 20.05 1.76719 20.05 1.37552 19.825L1.21719 19.7166ZM9.10885 10.0833L0.742188 18.4333V1.74163L9.10885 10.0833ZM14.3339 6.63329L18.4255 8.89996C18.8255 9.12496 19.0755 9.54163 19.0755 9.99163C19.0755 10.4416 18.8255 10.8666 18.4255 11.0833L14.2255 13.4083L10.8839 10.075L14.3422 6.62496L14.3339 6.63329ZM1.12552 0.358294C1.20052 0.283294 1.28385 0.22496 1.37552 0.166627C1.76719 -0.0583731 2.25885 -0.0667065 2.65052 0.158294L13.1922 5.99996L9.98385 9.19996L1.12552 0.358294Z"
    />
  </Base>
)

export default Android24
